import RightSectionContainer, {
	RightSectionContainerProps,
} from "./RightSectionContainer";

const Resume = (props: Props) => {
	return (
		<RightSectionContainer
			{...props}
			style={{
				position: "sticky",
				top: 48,
				flex: "unset",
				padding: "24px",
				boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
				border: "1px solid rgba(0, 29, 61, 0.10)",
				borderRadius: 12,
				minWidth: 380,
				marginLeft: 0,
				backgroundColor: "white",
				...props.style,
			}}
			childrenProps={{
				...props.childrenProps,
				style: {
					overflow: "hidden",
					marginTop: 0,
					marginBottom: 0,
					...props.childrenProps?.style,
				},
			}}
			dataContainerStyle={{ justifyContent: "flex-start" }}
		>
			{props.children}
		</RightSectionContainer>
	);
};
export default Resume;
export interface Props extends RightSectionContainerProps {}
